import { CLAIM_TYPES } from 'Data/payments.js'
import { useDataSubmit, useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let receivable_id = useDataValue({
    context: 'entry',
    path: 'transaction.transfer_charge.charge_transfer_adjustment.transaction.receivable.id',
    viewPath: props.viewPath,
  })
  let submit = useDataSubmit({
    context: 'entry',
    viewPath: props.viewPath,
  })
  return function onClick() {
    submit({ type: 'FOCUS_RECEIVABLE', receivable_id })
  }
}

export function getText(receivable) {
  return `${CLAIM_TYPES.includes(receivable.rtype) ? 'Claim' : 'Invoice'} #${receivable.human_readable_id}`
}
